import React from 'react';

let versionNoStyle = {
    left: '50%',
    transform: 'translate(-50%, 0)',
    paddingBottom:20,
    position: 'fixed', 
    bottom: 0,
    fontSize:20,
    color: '#9B9B9B',
    backgroundColor: "#EBEBEB",
    width: '100%',
    textAlign: 'center',
    padding: '10px'
}
export default function VersionFooter() {
    return (
        <div style={versionNoStyle} >Checklist app V.1.2 — 18 May, 2023</div>
    )
}